require('./$.set-species')('Array');


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/es6.array.species.js
 ** module id = 122
 ** module chunks = 1
 **/